var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-text-box"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))]),(_vm.btnText != '' && _vm.showBtn)?_c('Btn',{staticClass:"float-left",class:_vm.btnType,attrs:{"icon":_vm.buttonIconCmp,"btnText":_vm.btnText},on:{"btnClick":_vm.emitAction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }